module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opis",
      "error": _vm.errors[_vm.addLanguageSuffix('description')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('description')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('description'), $$v)
      },
      expression: "form[addLanguageSuffix('description')]"
    }
  })], 1), _vm._v(" "), _c('edition-input', {
    attrs: {
      "errors": _vm.errors.edition,
      "required": true
    },
    model: {
      value: (_vm.form.edition),
      callback: function($$v) {
        _vm.$set(_vm.form, "edition", $$v)
      },
      expression: "form.edition"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Popup"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Wybierz popup"
    },
    model: {
      value: (_vm.form.popup),
      callback: function($$v) {
        _vm.$set(_vm.form, "popup", $$v)
      },
      expression: "form.popup"
    }
  }, _vm._l((_vm.popups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.working_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Logotyp",
      "error": _vm.errors['logotype']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.logotype),
      callback: function($$v) {
        _vm.$set(_vm.form, "logotype", $$v)
      },
      expression: "form.logotype"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kategoria główna",
      "error": _vm.errors['category']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Kategoria"
    },
    model: {
      value: (_vm.form.category),
      callback: function($$v) {
        _vm.$set(_vm.form, "category", $$v)
      },
      expression: "form.category"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.name_pl,
        "value": category.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Podkategorie",
      "error": _vm.errors['tags']
    }
  }, [_c('el-select', {
    staticClass: "fluid",
    attrs: {
      "filterable": "",
      "multiple": "",
      "default-first-option": "",
      "placeholder": "Tagi",
      "allow-create": ""
    },
    model: {
      value: (_vm.form['tags']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'tags', $$v)
      },
      expression: "form['tags']"
    }
  }, _vm._l((_vm.availableTags), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Miejsca",
      "error": _vm.errors['stages']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "Sceny"
    },
    model: {
      value: (_vm.form.stages),
      callback: function($$v) {
        _vm.$set(_vm.form, "stages", $$v)
      },
      expression: "form.stages"
    }
  }, _vm._l((_vm.$store.state.stages), function(stage) {
    return _c('el-option', {
      key: stage.id,
      attrs: {
        "label": stage.name_pl,
        "value": stage.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box__header box__header--photos"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Zdjęcia:")])]), _vm._v(" "), _c('photo-cropper', {
    attrs: {
      "photo": _vm.form.photo,
      "errors": _vm.errors,
      "croppers": _vm.croppers
    },
    on: {
      "update:photo": function($event) {
        return _vm.$set(_vm.form, "photo", $event)
      },
      "update:croppers": function($event) {
        _vm.croppers = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Widgety - widoczne w szczegółach:")])]), _vm._v(" "), _c('widgets-input', {
    attrs: {
      "widgets": _vm.form.widgets,
      "errors": _vm.errors.widgets || []
    },
    on: {
      "update:widgets": function($event) {
        return _vm.$set(_vm.form, "widgets", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1), _vm._v(" "), _c('label', [_vm._v("\n                        Ukryj\n                        "), _c('el-switch', {
    model: {
      value: (_vm.form.hide),
      callback: function($$v) {
        _vm.$set(_vm.form, "hide", $$v)
      },
      expression: "form.hide"
    }
  })], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a32a9e50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Stands/StandForm.vue
// module id = 790
// module chunks = 0